module.exports = __webpack_public_path__ + "img/icon-close.795daaab.svg";